import React, { useState, useRef } from "react";
import { Link } from "gatsby"
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Overlay, Tooltip } from "react-bootstrap"
import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from "react-share";
import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from "react-share";
import { PageLinks } from "../../common/page-links";

const ShareBtn = ({ property_data, location, className }) => {

    const shareurl = typeof window !== 'undefined' ? window.location.href : ''
    const target = useRef(null);

    const [Shareicons, setShareicons] = React.useState(false);
    const [copied, setCopied] = useState(false);
    const openShareicons = () => {
        setShareicons(!Shareicons); 
    }

    const trackerShare = (event) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'Share - social icons',
            'formType': event + ' - ' + shareurl,
            'formId': 'Share',
            'formName': 'Share',
            'formLabel': 'Share'
        });
    }

    return (
        <React.Fragment>
            <div className={`icon-wrap share_icon`}>
                <a href="javascript:;" onClick={openShareicons}>
                    <i className="icon-share"></i>
                </a>

                {Shareicons &&
                    <div  className={`property-share-social-icons ${className}`}>
                        <FacebookShareButton onClick={() => trackerShare('FacebookShareButton')} url={shareurl} className="my-share-button facebook-share">
                            <FacebookIcon size={32} round={false} borderRadius={`10`} />
                        </FacebookShareButton>
                        {/* <TwitterShareButton onClick={() => trackerShare('TwitterShareButton')} url={shareurl} className="my-share-button twitter-share">
                            <TwitterIcon size={32} round={false} borderRadius={`10`} />
                        </TwitterShareButton> */}
                        <LinkedinShareButton onClick={() => trackerShare('LinkedinShareButton')} url={shareurl} className="my-share-button linkedin-share">
                            <LinkedinIcon size={32} round={false} borderRadius={`10`} />
                        </LinkedinShareButton>
                        <WhatsappShareButton onClick={() => trackerShare('WhatsappShareButton')} url={shareurl} className="my-share-button whatsapp-share">
                            <WhatsappIcon size={32} round={false} borderRadius={`10`} />
                        </WhatsappShareButton>
                        <Link to={`/${PageLinks.send_to_friend}/`} state={{ property_data, form_type: "send_to_friend", property_url: shareurl }}  onClick={()=> { trackerShare('SendToFriend')}} className="my-share-button email-share">
                            <EmailIcon size={32} round={false} borderRadius={`10`} />
                        </Link>
                        <CopyToClipboard 
                            onCopy={() => setCopied(true)}
                            text={shareurl}
                        >
                            <button className="react-share__ShareButton my-share-button copy-btn"
                                ref={target}
                            onClick={() => {
                               
                                setCopied(true)
                                setTimeout(() => {
                                    setCopied(false)
                                } , 1000)
                            }}
                            >
                                <i className="copy-icon"></i>
                            </button>
                        </CopyToClipboard>
                        <Overlay  target={target.current}  show={copied} placement="right">
                            {(props) => (
                                <Tooltip id="overlay-example" {...props}>
                                    Copied!
                                </Tooltip>
                            )}
                        </Overlay>
                    </div>
                }
            </div>
        </React.Fragment>
    );
};
export default ShareBtn;
